<script>
  import { fade } from 'svelte/transition';
  
  const team = [
    {
      name: 'Kiran Ramaiah',
      title: 'Chief Executive Officer',
      image: '/kiran.png'
    },
    {
      name: 'Anongu Silas',
      title: 'Founding Tech Lead',
      image: '/silas.png'
    },
    {
      name: 'Ninad Yadav',
      title: 'Chief Operating Officer',
      image: '/ninad.png'
    }
  ];
</script>

<section class="py-24">
  <div class="container mx-auto px-4">
    <div class="max-w-4xl mx-auto text-center mb-16">
      <h2 
        class="text-4xl md:text-5xl lg:text-6xl font-bold mb-6"
        in:fade={{ duration: 300, delay: 150 }}
      >
        <span class="text-[#C6C8CF]">Our</span>
        <span class="text-[#070811]">Team</span>
      </h2>
      
      <p 
        class="text-[#43444D] text-lg max-w-3xl mx-auto"
        in:fade={{ duration: 300, delay: 300 }}
      >
      </p>
    </div>

    <div class="flex flex-wrap justify-center items-center gap-8 max-w-5xl mx-auto">
      {#each team as member, i}
        <div 
          class="group"
        >
          <div class="relative aspect-square w-full min-w-40 sm:w-60 lg:w-80 mb-6 rounded-2xl overflow-hidden transform transition-transform duration-300">
            <img
              src={member.image}
              alt={member.name}
              class="w-full object-cover"
            />
            <div class="absolute inset-0 bg-[#536aff]/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          </div>
          
          <h3 class="text-am-black text-xl font-semibold">
            {member.name}
          </h3>
          
          <p class="text-am-black-75">
            {member.title}
          </p>
        </div>
      {/each}
    </div>
  </div>
</section>

<style>
  /* Optional: Add smooth shadow on hover */
  .group {
    transition: transform 0.3s ease;
  }
  
  .group:hover {
    transform: translateY(-4px);
  }
</style>
